import { TokenConstants } from './constants'
import {OrganizationService, TokenService} from '../../services'

export const setDefaultOrganization = (organization) => {
  return (dispatch) => {
    dispatch({
      type: TokenConstants.SET_TOKEN_INFO,
      response: { organization: organization },
    })
  }
}

export const setCurrentDisplayToken = (token) => {
  return (dispatch) => {
    dispatch({
      type: TokenConstants.SET_CURRENT_DISPLAY_TOKEN,
      response: token,
    })
  }
}

export const setCounterNumber = (counterNumber) => {
  return (dispatch) => {
    dispatch({
      type: TokenConstants.SET_COUNTER_NUMBER,
      response: { counterNumber: counterNumber },
    })
  }
}
export const setCategory = (category) => {
  return (dispatch) => {
    dispatch({
      type: TokenConstants.SET_COUNTER_CATEGORY,
      response: { tokenCategory: category },
    })
  }
}

export const getTokensToDisplay = (organization) => {
  return (dispatch) => {
    new TokenService()
      .makeGetRequest({
        location_code: organization.token_machine_location_code,
        page_size: 1000,
      })
      .then((response) => {
        dispatch({
          type: TokenConstants.SET_INITIAL_DISPLAY_TOKENS,
          response: response.results,
        })
      })
  }
}

// Pick the "now serving" token out of an authoritative token list: the token
// invited to a counter most recently (invite_sent_on is set by the backend's
// invite_customer_to_counter action, the same path that POSTs the `call`
// command). Used to recover a `call` that the display missed while its socket
// was briefly down, since WebSocket frames are not replayed.
const findCurrentlyServedToken = (tokens) => {
  if (!Array.isArray(tokens)) {
    return null
  }
  let current = null
  for (const token of tokens) {
    if (!token || !token.invite_sent_on || token.has_customer_left) {
      continue
    }
    if (!current || new Date(token.invite_sent_on) > new Date(current.invite_sent_on)) {
      current = token
    }
  }
  return current
}

// Resync authoritative display state after a (re)connect. Refetches the token
// list (self-heals a missed `reload`) and, from that same authoritative
// payload, restores the current "now serving" token (self-heals a missed
// `call`). Reuses the existing TokenService list request and the existing
// SET_INITIAL_DISPLAY_TOKENS / SET_CURRENT_DISPLAY_TOKEN actions so no new
// backend contract or infra is introduced.
export const resyncDisplayState = (organization) => {
  return (dispatch, getState) => {
    return new TokenService()
      .makeGetRequest({
        location_code: organization.token_machine_location_code,
        page_size: 1000,
      })
      .then((response) => {
        dispatch({
          type: TokenConstants.SET_INITIAL_DISPLAY_TOKENS,
          response: response.results,
        })
        const current = findCurrentlyServedToken(response.results)
        // Only (re)assert the now-serving token when it actually differs from
        // what the display already shows. SET_CURRENT_DISPLAY_TOKEN replaces
        // currentDisplayToken with a new object, which re-triggers the audio
        // announcement; dispatching it on every reconnect would replay the
        // "now serving" call in a loop. Comparing by `url` (the token's stable
        // identity) means a reconnect that recovers nothing new stays silent,
        // while a genuinely missed `call` is still restored and announced once.
        const existing =
          getState().tokens && getState().tokens.currentDisplayToken
        if (current && (!existing || existing.url !== current.url)) {
          dispatch({
            type: TokenConstants.SET_CURRENT_DISPLAY_TOKEN,
            response: current,
          })
        }
      })
  }
}
export const getAverageServiceTime = (organization) => {
  return (dispatch) => {
    new OrganizationService().
      average_service_time(organization.code)
      .then((response) => {
        dispatch({
          type: TokenConstants.SET_AVG_SERVICE_TIME,
          response: response,
        })
      })
  }
}
export const setMachineID = (value) => {
  return (dispatch) => {
    dispatch({
      type: TokenConstants.SET_MACHINE_ID,
      response: { machine_id: value },
    })
  }
}
